module.exports = __webpack_public_path__ + "img/play-mind.f83f5ac1.svg";